import BlazonExpiration from 'app/common/modals/blazon/body/expiration/BlazonExpiration'
import BlazonLegalNotice from 'app/common/modals/blazon/body/legal-notice/BlazonLegalNotice'
import BlazonRewards from 'app/common/modals/blazon/body/rewards/BlazonRewards'
import React from 'react'
import type { Blazon } from 'shared/types'
import styled from 'styled-components'

type Props = {
    blazon: Blazon
}

const BlazonModalBody = (props: Props) => {
    const { blazon } = props
    const { reward, endDate, legalMentions } = blazon

    return (
        <Root>
            <BlazonRewards reward={reward} />
            <BlazonExpiration endDate={endDate} />
            {!!legalMentions && (
                <BlazonLegalNotice legalMentions={legalMentions} />
            )}
        </Root>
    )
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`

export default BlazonModalBody
